var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "navbar-settings"
  }, [_c('v-btn', {
    staticClass: "navbar-settings__btn",
    attrs: {
      "text": "",
      "aria-label": "Recording settings",
      "aria-haspopup": "true",
      "aria-expanded": String(_vm.isOpen)
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.toggle.apply(null, arguments);
      }
    }
  }, [_c('svg', {
    staticClass: "navbar-settings__icon",
    attrs: {
      "viewBox": "0 0 24 24",
      "width": "22",
      "height": "22",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.06-.94l2.03-1.58a.5.5 0 00.12-.64l-1.92-3.32a.5.5 0 00-.6-.22l-2.39.96a7.03 7.03 0 00-1.63-.94l-.36-2.54A.49.49 0 0013.9 2h-3.8a.49.49 0 00-.49.42l-.36 2.54c-.59.24-1.13.55-1.63.94l-2.39-.96a.5.5 0 00-.6.22L2.71 8.48a.5.5 0 00.12.64l2.03 1.58c-.04.31-.06.63-.06.94s.02.63.06.94L2.83 14.16a.5.5 0 00-.12.64l1.92 3.32c.14.24.43.34.69.22l2.39-.96c.5.39 1.04.7 1.63.94l.36 2.54c.05.24.25.42.49.42h3.8c.24 0 .44-.18.49-.42l.36-2.54c.59-.24 1.13-.55 1.63-.94l2.39.96c.26.12.55.02.69-.22l1.92-3.32a.5.5 0 00-.12-.64l-2.03-1.58zM12 15.5A3.5 3.5 0 1112 8.5a3.5 3.5 0 010 7z"
    }
  })])]), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpen,
      expression: "isOpen"
    }],
    staticClass: "navbar-settings__menu",
    attrs: {
      "role": "menu"
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "navbar-settings__header"
  }, [_vm._v("Settings")]), _c('ThemeToggle', {
    attrs: {
      "menu": ""
    }
  }), _vm.showLocalSave ? _c('LocalDataSaveToggle', {
    attrs: {
      "menu": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('local-save-change', $event);
      }
    }
  }) : _vm._e(), _vm.showLidar ? _c('LidarToggle', {
    attrs: {
      "menu": ""
    },
    on: {
      "change": function ($event) {
        return _vm.$emit('lidar-change', $event);
      }
    }
  }) : _vm._e()], 1)])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }